import Text from "components/Text/Text"
import confirmModals from "stores/confirmModals"
import { useList } from 'effector-react'
import ConfirmModal, { IConfirmModalProps } from "components/ConfirmModal/ConfirmModal"
import useLocationChange from "hooks/useLocationChange"

const ConfirmModals = () => {
    useLocationChange(confirmModals.clear)

    async function handleClose(props: IConfirmModalProps) {
        if (typeof props.onClose === "function") {
            await props.onClose()
        }
        confirmModals.hide(props)
    }

    return useList(confirmModals.list, (props: IConfirmModalProps, idx) => (
        <ConfirmModal
            {...props}
            onClose={() => handleClose(props)}
            key={idx}>
            <Text>{props.children}</Text>
        </ConfirmModal>
    ))
}

export default ConfirmModals
